export default __webpack_public_path__ + "static/media/asset6.e33d6ef2.png";